import { useContext, useState } from 'react';
import { Grid, Typography, Table, MenuItem, TextField, Button, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { DeleteIconButton, SimecUser } from 'components';
import { applicationContext } from 'helpers/services';
import moment from 'moment';
import Moment from 'react-moment';
import { toolContext, IToolUser } from '../ToolDetailsContext';



let ToolUsers = () => {
    let service = useContext(toolContext);
    let { simecUsers } = useContext(applicationContext);

    const defaultToolUser: IToolUser = {
        userName: '',
        startDate: null,
        endDate: null,
    }

    let [showAddUserForm, setShowAddUserForm] = useState<boolean>(false);
    let [editToolUserIx, setEditToolUserIx] = useState<number | null>(null);
    let [editToolUser, setEditToolUser] = useState<IToolUser>({} as IToolUser);

    let [toolUser, setToolUser] = useState<IToolUser>(defaultToolUser);


    let handleChangeToolUsers = (toolUserFormData: IToolUser, action: 'add' | 'edit' | 'delete') => {
        service.handleChangeToolUsers(toolUserFormData, action);
        setToolUser(defaultToolUser);
        setEditToolUser(defaultToolUser);
        setEditToolUserIx(null);
        if (action === 'add') {
            setShowAddUserForm(false);
        }
    }

    let closeAddUserForm = () => {
        setToolUser(defaultToolUser);
        setShowAddUserForm(false);
    }

    let handleDeleteUser = (user: IToolUser) => {
        if (window.confirm("Vuoi eliminare questo Utente?")) {
            handleChangeToolUsers(user, 'delete');
        }
    }


    return (
        <Grid item xs={12}>
            <Typography variant="h5">Assegnazioni</Typography>

            {showAddUserForm === true &&
                <Grid container>
                    <Grid item xs={12} md={9}>
                        <Grid container>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    label="Seleziona utente"
                                    size="small"
                                    value={toolUser.userName}
                                    onChange={(e) => setToolUser({ ...toolUser, userName: e.target.value })}
                                >
                                    {simecUsers
                                        .filter(x => x.simecClaims.canGoToCustomer === true)
                                        .map(u => <MenuItem key={u.email} value={u.email}>{u.firstName} {u.lastName}</MenuItem>)}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <DesktopDatePicker
                                    label="Data uscita"
                                    value={toolUser.startDate}
                                    onChange={(value) => setToolUser({ ...toolUser, startDate: value != null ? moment(value) : null })}
                                    renderInput={(props) => <TextField {...props} size='small' />}
                                    inputFormat="DD/MM/YYYY"
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid item xs />
                    <Grid item>
                        <Button variant="contained" onClick={() => handleChangeToolUsers(toolUser, 'add')}>
                            Aggiungi
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => closeAddUserForm()}
                        >
                            Annulla
                        </Button>
                    </Grid>
                </Grid>
            }

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Utente</TableCell>
                        <TableCell>Data Uscita</TableCell>
                        <TableCell>Data Rientro</TableCell>
                        <TableCell align="right">
                            {showAddUserForm === false &&
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => setShowAddUserForm(true)}
                                >
                                    Aggiungi
                                </Button>
                            }
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.toolUsers.length <= 0 &&
                        <TableRow>
                            <TableCell colSpan={12}>
                                <Typography variant="subtitle2">Nessuna Assegnazione</Typography>
                            </TableCell>
                        </TableRow>
                    }
                    {service.toolUsers.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell>
                                <SimecUser username={user.userName} />
                            </TableCell>
                            <TableCell>
                                {editToolUserIx === index &&
                                    <DesktopDatePicker
                                        label="Data da"
                                        value={editToolUser.startDate}
                                        onChange={(value) => setEditToolUser({ ...toolUser, startDate: value != null ? moment(value) : null })}
                                        renderInput={(props) => <TextField {...props} size='small' />}
                                        inputFormat="DD/MM/YYYY"
                                    />
                                }
                                {editToolUserIx !== index &&
                                    <>
                                        {!user.startDate && '-'}
                                        {user.startDate && <Moment date={user.startDate} format="LL" />}
                                    </>
                                }
                            </TableCell>
                            <TableCell>
                                {!user.endDate &&
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => service.openSetAvailable(user)}
                                    >
                                        Rientra
                                    </Button>
                                }
                                {user.endDate &&
                                    <Moment date={user.endDate} format="LL" />
                                }
                            </TableCell>
                            <TableCell align="right">
                                {editToolUserIx !== index &&
                                    <DeleteIconButton onClick={() => handleDeleteUser(user)} />
                                }
                                {editToolUserIx === index &&
                                    <>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleChangeToolUsers(editToolUser, 'edit')}
                                        >
                                            Salva
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => setEditToolUserIx(null)}
                                        >
                                            Annulla
                                        </Button>
                                    </>
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Grid>
    )
}

export default ToolUsers;